import React from "react";
import { Col, Row } from "antd";
import { useHistory } from "react-router-dom";

import FormInput from "components/FormInput/FormInput";
import Title from "components/Title/Title";

import { buildAWPersonalUri } from "utils/routes";

import LoansSection from "./components/LoansSection/LoansSection";
import PolicySection from "components/PolicySection/PolicySection";
import FormToggle from "components/FormToggle/FormToggle";
import { Label } from "./AWFinancialInfo.styles";
import Locale from "react-intl-universal";

const AWFinancialInfo = ({
  allowToAccess,
  onFieldFocus,
  loans,
  setLoans,
  policies,
  setPolicies,
}) => {
  const history = useHistory();
  if (!allowToAccess) {
    history.push(buildAWPersonalUri());
    return null;
  }
  return (
    <>
      <Title marginBottom="24px">
        {Locale.get("addNewAdvisee.financialInfo.pageTitle")}
      </Title>
      <Row>
        <Col span={24}>
          <FormInput
            label={Locale.get("addNewAdvisee.financialInfo.totalIncome")}
            name="totalIncome"
            placeholder="0.00"
            type="financial"
            suffix="/ month"
            onFocus={onFieldFocus}
          />
        </Col>
        <Col span={24}>
          <FormInput
            label={Locale.get("addNewAdvisee.financialInfo.totalExpenses")}
            name="totalExpenses"
            placeholder="0.00"
            type="financial"
            suffix="/ month"
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.financialInfo.errMsgTotalExpenses"
            )}
            onFocus={onFieldFocus}
          />
        </Col>
      </Row>
      <Title marginBottom="24px">
        {Locale.get("addNewAdvisee.financialInfo.headerTitle")}
      </Title>
      <Row>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={24}>
              <Label>
                {Locale.get("addNewAdvisee.financialInfo.tpdLabel")}
              </Label>
            </Col>
            <Col span={12}>
              <FormInput
                label={Locale.get("addNewAdvisee.financialInfo.minYear")}
                name={["yearsOfTPDCoverage", "min"]}
                placeholder="10"
                suffix={Locale.get("addNewAdvisee.financialInfo.yearSuffix")}
                extraProps={{
                  type: "number",
                }}
                requiredErrorMessage={Locale.get(
                  "addNewAdvisee.financialInfo.errMsgTpdMin"
                )}
                onFocus={onFieldFocus}
              />
            </Col>
            <Col span={12}>
              <FormInput
                label={Locale.get("addNewAdvisee.financialInfo.maxYear")}
                name={["yearsOfTPDCoverage", "max"]}
                placeholder="20"
                suffix={Locale.get("addNewAdvisee.financialInfo.yearSuffix")}
                extraProps={{
                  type: "number",
                }}
                requiredErrorMessage={Locale.get(
                  "addNewAdvisee.financialInfo.errMsgTpdMax"
                )}
                onFocus={onFieldFocus}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={16}>
            <Col span={24}>
              <Label>{Locale.get("addNewAdvisee.financialInfo.ciLabel")}</Label>
            </Col>
            <Col span={12}>
              <FormInput
                label={Locale.get("addNewAdvisee.financialInfo.minYear")}
                name={["yearsOfCICoverage", "min"]}
                placeholder="3"
                suffix={Locale.get("addNewAdvisee.financialInfo.yearSuffix")}
                extraProps={{
                  type: "number",
                }}
                requiredErrorMessage={Locale.get(
                  "addNewAdvisee.financialInfo.errMsgCiMin"
                )}
                onFocus={onFieldFocus}
              />
            </Col>
            <Col span={12}>
              <FormInput
                label={Locale.get("addNewAdvisee.financialInfo.maxYear")}
                name={["yearsOfCICoverage", "max"]}
                placeholder="5"
                suffix={Locale.get("addNewAdvisee.financialInfo.yearSuffix")}
                extraProps={{
                  type: "number",
                }}
                requiredErrorMessage={Locale.get(
                  "addNewAdvisee.financialInfo.errMsgCiMax"
                )}
                onFocus={onFieldFocus}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <FormInput
            label={Locale.get("addNewAdvisee.financialInfo.ideLabel")}
            name="immediateDeathAmt"
            placeholder="e.g. 58,000.00"
            type="financial"
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.financialInfo.errMsgIde"
            )}
            onFocus={onFieldFocus}
          />
        </Col>
        <Col span={24}>
          <FormInput
            label={Locale.get("addNewAdvisee.financialInfo.rrfLabel")}
            name="recoverRecuperatingFund"
            placeholder="e.g. 10,000.00"
            type="financial"
            onFocus={onFieldFocus}
          />
        </Col>
        <Col span={24}>
          <FormInput
            label={Locale.get("addNewAdvisee.financialInfo.medicalLabel")}
            name="medicalHealthInsuranceNeeds"
            placeholder="e.g. 200,000.00"
            type="financial"
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.financialInfo.errMsgMedical"
            )}
            onFocus={onFieldFocus}
          />
        </Col>
      </Row>

      <LoansSection loans={loans} updateLoans={setLoans} />
      <FormToggle
        label={Locale.get("addNewAdvisee.financialInfo.toggleLabel_0")}
        name="hasPolicy"
      >
        <PolicySection policies={policies} updatePolicies={setPolicies} />
      </FormToggle>
    </>
  );
};

export default AWFinancialInfo;
